export function validateName(name: string): boolean {
  const regex = /^[A-Za-zÀ-ÿ\s]+$/
  return regex.test(name.trim())
}
